/* Doucevent : carrousels et date de livraison estimée, communs à toutes les pages. */
(function(){
  /* Carrousels : boutons précédent/suivant, barre de progression, désactivation aux extrémités. */
  function initSlider(root){
    var track=root.querySelector('[data-dv-strack]');if(!track)return;
    var prev=root.querySelector('[data-dv-sprev]'),next=root.querySelector('[data-dv-snext]'),bar=root.querySelector('[data-dv-sbar]');
    function step(){var s=track.children[0];if(!s)return track.clientWidth;var g=parseFloat(getComputedStyle(track).columnGap)||0;return s.getBoundingClientRect().width+g;}
    function update(){
      var max=track.scrollWidth-track.clientWidth;
      root.classList.toggle('is-static',max<=2);
      if(prev)prev.disabled=track.scrollLeft<=2;
      if(next)next.disabled=track.scrollLeft>=max-2;
      if(bar){var vis=track.scrollWidth?track.clientWidth/track.scrollWidth:1;var w=Math.max(vis*100,8);bar.style.width=w+'%';bar.style.transform='translateX('+(max>0?(track.scrollLeft/max)*(100/w*100-100):0)+'%)';}
    }
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();next&&next.click();}if(e.key==='ArrowLeft'){e.preventDefault();prev&&prev.click();}});
    update();setTimeout(update,400);
  }
  /* Date estimée : 7 à 15 jours ouvrés après aujourd'hui. */
  function addBiz(d,k){d=new Date(d);while(k>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w&&w<6)k--;}return d;}
  function fmt(d,o){return d.toLocaleDateString('fr-FR',o||{weekday:'long',day:'numeric',month:'long'});}
  function eta(){
    var t=new Date();
    document.querySelectorAll('[data-dv-eta]').forEach(function(e){e.textContent='entre le '+fmt(addBiz(t,7))+' et le '+fmt(addBiz(t,15));});
    document.querySelectorAll('[data-dv-eta-end]').forEach(function(e){e.textContent=fmt(addBiz(t,15),{day:'numeric',month:'long'});});
    var mid=new Date(t);mid.setHours(24,0,0,0);var s=Math.max(0,Math.floor((mid-t)/1000));var h=Math.floor(s/3600),m=Math.floor(s%3600/60);
    document.querySelectorAll('[data-dv-clock]').forEach(function(e){e.textContent=(h?h+' h ':'')+(m<10&&h?'0':'')+m+' min';});
  }
  function boot(){document.querySelectorAll('[data-dv-slider]').forEach(initSlider);eta();setInterval(eta,30000);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
